<template>
  <transition name="fade" appear>
    <div class="c-popup c-popup--result" v-show="modal">
      <!-- break time modal -->
      <popup-modal v-model=workStore.isBreakTimeModal @close-layer="closeBreakTimeModal" @close="closeBreakTimeModal">
        <template #main>
          <div class="c-popup-body__title">
            <p class="c-popup-body__title-text">
              がんばってますね！ 少し目を休めませんか？
            </p>
          </div>
          <div class="c-popup-body__contents">
            <div>
              <p>
                目の健康のために ３０分に１回程度<br>
                遠くを見たり 目を休めることをおすすめします。    
              </p>
              <p>
                腕や背中を伸ばして、窓の外を見てみましょう。
              </p>
            </div>
            <div>
              <img src="@/styles/img/common/img_character_4.png" alt="" width="129" height="93">
            </div>
          </div>
        </template>
        <template #footer>
          <label class="c-form-checkbox-area" for="no-message">
            <input type="checkbox" class="c-form-checkbox" id="no-message" v-model="isChecked">
            <span class="c-form-checkbox-label -large">しばらくこのメッセージを表示しない</span>
          </label>  
          <p class="c-button-blue -medium" @click="closeBreakTimeModal">
            <span class="label">学習を続ける</span>
          </p>
        </template>
      </popup-modal>
      <div class="c-popup__inner">
        <div class="c-popup-body">
          <div class="c-popup-body__inner">
            <div class="c-popup-body__main">
              <slot name="main"></slot>
            </div>
            <div class="c-popup-body__footer">
              <div class="c-popup-body__overwrap">
                <div class="btnBlock">
                  <slot name="footer"></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
  import {ref, computed} from "vue";
  import { useWorkStore } from '@/store/student/work_store';
  import { useAccountStore } from '@/store/student/account_store';

  const workStore = useWorkStore()
  const accountStore = useAccountStore()
  const isChecked = ref(true)

  const props = withDefaults(
    defineProps<{
      modelValue?: boolean;
    }>(),
    {
      modelValue: false,
    }
  );

  const modal = computed(() => {
    return props.modelValue
  })

  // NFR-4415 休憩モーダルを閉じる。
  async function closeBreakTimeModal(){
    workStore.saveIsBreakTimeModal(false)
    // NFR-4551 モーダルを閉じるときチェックボックス状態をsettingsにupdateする。
    await accountStore.fetchUpdateSettings({ "settings": { "is_break_time": !isChecked.value } });
    accountStore.saveBreakTimeSetting(!isChecked.value);

  }
</script>